module.exports = __webpack_public_path__ + "school/img/shou-2.17a3f74b.jpg";